module.exports = __webpack_public_path__ + "img/btn_cs.c0b2e0ff.svg";